import { MENU_VIEW } from 'src/enums/menu';
import { SIDE_PANEL_SIZES } from 'src/enums/side-panel-size';

export const sidePanelSize = {
    [SIDE_PANEL_SIZES.MEDIUM]: () => '300px',
    [SIDE_PANEL_SIZES.LARGE]: () => '450px',
    [SIDE_PANEL_SIZES.FULL]: (menuView?: MENU_VIEW) => (menuView === MENU_VIEW.MAXIMIZE ? 'calc(100% - 322px)' : 'calc(100% - 113px)'),
};
